/**
 * @flow
 * @relayHash 81dd09c31cd7df61f154dc4d66489238
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobSubComponents_job$ref = any;
type JobsTable_jobEdges$ref = any;
export type JobStatus = "CLOSED" | "OPEN";
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type UOMType = "LENGTH" | "QUANTITY" | "WEIGHT";
export type UpdateJobSubComponentInput = {|
  itemId: string,
  jobId: string,
  usageQty: number,
|};
export type UpdateJobSubComponentMutationVariables = {|
  input: UpdateJobSubComponentInput
|};
export type UpdateJobSubComponentMutationResponse = {|
  +updateJobSubComponent: {|
    +jobEdge: {|
      +node: {|
        +id: string,
        +importJobNumber: ?string,
        +jobNumber: string,
        +name: string,
        +status: JobStatus,
        +subComponents: {|
          +edges: ?$ReadOnlyArray<?{|
            +usageQty: ?number,
            +node: {|
              +id: string,
              +itemNumber: string,
              +name: string,
              +upc: ?string,
              +partNumber: ?string,
              +description: ?string,
              +category: ?{|
                +id: string,
                +name: string,
              |},
              +quantityUOM: {|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +weightUOM: ?{|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +dimensionUOM: ?{|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +formFieldValues: any,
              +dimensionLength: ?number,
              +dimensionWidth: ?number,
              +dimensionHeight: ?number,
              +weight: ?number,
            |},
          |}>
        |},
        +user: ?{|
          +id: string,
          +firstName: string,
          +lastName: string,
        |},
        +order: ?{|
          +id: string,
          +promisedAt: ?any,
          +orderNumber: string,
          +status: OrderStatus,
          +customer: {|
            +id: string,
            +name: string,
          |},
        |},
        +$fragmentRefs: JobSubComponents_job$ref,
      |},
      +$fragmentRefs: JobsTable_jobEdges$ref,
    |}
  |}
|};
export type UpdateJobSubComponentMutation = {|
  variables: UpdateJobSubComponentMutationVariables,
  response: UpdateJobSubComponentMutationResponse,
|};
*/


/*
mutation UpdateJobSubComponentMutation(
  $input: UpdateJobSubComponentInput!
) {
  updateJobSubComponent(input: $input) {
    jobEdge {
      ...JobsTable_jobEdges
      node {
        ...JobSubComponents_job
        id
        importJobNumber
        jobNumber
        name
        status
        subComponents {
          edges {
            usageQty
            node {
              id
              itemNumber
              name
              upc
              partNumber
              description
              category {
                id
                name
              }
              quantityUOM {
                id
                name
                type
                symbol
              }
              weightUOM {
                id
                name
                type
                symbol
              }
              dimensionUOM {
                id
                name
                type
                symbol
              }
              formFieldValues
              dimensionLength
              dimensionWidth
              dimensionHeight
              weight
            }
          }
        }
        user {
          id
          firstName
          lastName
        }
        order {
          id
          promisedAt
          orderNumber
          status
          customer {
            id
            name
          }
        }
      }
    }
  }
}

fragment JobsTable_jobEdges on JobEdge {
  node {
    id
    jobNumber
    importJobNumber
    name
    status
    createdAt
    user {
      id
      ...UserAvatar_user
    }
    yields {
      totalCount
    }
    order {
      id
      promisedAt
      customer {
        id
        name
      }
    }
    states {
      id
      isEnabled
      status
      workflowState {
        id
        name
        type
      }
    }
    workflow {
      id
      states {
        id
        name
        isRequired
        type
      }
      transitions {
        id
        toWorkflowState {
          id
        }
        fromWorkflowState {
          id
        }
      }
    }
    ...AddUpdateJobModal_job
    ...DeleteJobModal_job
  }
}

fragment JobSubComponents_job on Job {
  id
  ...AddUpdateJobSubComponentModal_job
  subComponents {
    edges {
      ...JobSubComponentsTree_jobSubComponentEdges
      usageQty
      node {
        id
        name
        partNumber
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  yields {
    edges {
      ...JobSubComponentsTree_jobYieldEdges
      cursor
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AddUpdateJobSubComponentModal_job on Job {
  id
  subComponents {
    edges {
      usageQty
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JobSubComponentsTree_jobSubComponentEdges on JobSubComponentEdge {
  usageQty
  node {
    id
    itemNumber
    name
    partNumber
    upc
    description
    category {
      id
      name
    }
    totalQty
    quantityUOM {
      id
      symbol
    }
    lotTracking
    childItems {
      edges {
        usageQty
        node {
          id
          itemNumber
          name
          partNumber
          upc
          totalQty
          quantityUOM {
            id
            symbol
          }
          category {
            id
            name
          }
          lotTracking
        }
      }
    }
    ...DeleteJobSubComponentModal_item
  }
}

fragment JobSubComponentsTree_jobYieldEdges on JobYieldEdge {
  node {
    id
    quantity
    item {
      id
      itemNumber
      name
      partNumber
      upc
      totalQty
      quantityUOM {
        id
        symbol
      }
      category {
        id
        name
      }
      lotTracking
      childItems {
        edges {
          usageQty
          node {
            id
            itemNumber
            name
            partNumber
            upc
            totalQty
            quantityUOM {
              id
              symbol
            }
            category {
              id
              name
            }
            lotTracking
          }
        }
      }
    }
  }
}

fragment DeleteJobSubComponentModal_item on Item {
  id
  name
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment AddUpdateJobModal_job on Job {
  id
  name
  notes
  user {
    id
  }
  workflow {
    id
    name
    states {
      id
      isGangRun
    }
  }
  order {
    id
  }
  yields {
    edges {
      node {
        id
        quantity
        itemNumberUp
        brokerCustomerOrderNumber
        formFieldValues
        overUnderRule
        overQuantity
        item {
          id
          name
          quantityUOM {
            id
            name
            symbol
          }
        }
      }
    }
  }
}

fragment DeleteJobModal_job on Job {
  id
  name
  order {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateJobSubComponentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "importJobNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jobNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "usageQty",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumber",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "upc",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "partNumber",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v12 = [
  (v2/*: any*/),
  (v5/*: any*/)
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCategory",
  "plural": false,
  "selections": (v12/*: any*/)
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v16 = [
  (v2/*: any*/),
  (v5/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "weightUOM",
  "storageKey": null,
  "args": null,
  "concreteType": "UOM",
  "plural": false,
  "selections": (v16/*: any*/)
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "dimensionUOM",
  "storageKey": null,
  "args": null,
  "concreteType": "UOM",
  "plural": false,
  "selections": (v16/*: any*/)
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "formFieldValues",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimensionLength",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimensionWidth",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimensionHeight",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "weight",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promisedAt",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderNumber",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "customer",
  "storageKey": null,
  "args": null,
  "concreteType": "Customer",
  "plural": false,
  "selections": (v12/*: any*/)
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalQty",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lotTracking",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "childItems",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemChildConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemChildEdge",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v8/*: any*/),
            (v5/*: any*/),
            (v10/*: any*/),
            (v9/*: any*/),
            (v29/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "quantityUOM",
              "storageKey": null,
              "args": null,
              "concreteType": "UOM",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v15/*: any*/)
              ]
            },
            (v13/*: any*/),
            (v30/*: any*/)
          ]
        }
      ]
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v35 = [
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateJobSubComponentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateJobSubComponent",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateJobSubComponentPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "subComponents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobSubComponentConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobSubComponentEdge",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v5/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "quantityUOM",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UOM",
                                "plural": false,
                                "selections": (v16/*: any*/)
                              },
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v6/*: any*/),
                      (v28/*: any*/)
                    ]
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "JobSubComponents_job",
                    "args": null
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "JobsTable_jobEdges",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateJobSubComponentMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateJobSubComponent",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateJobSubComponentPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "avatar",
                        "args": null,
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalCount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "quantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumberUp",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "brokerCustomerOrderNumber",
                                "args": null,
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overUnderRule",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overQuantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "quantityUOM",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UOM",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v5/*: any*/),
                                      (v15/*: any*/)
                                    ]
                                  },
                                  (v8/*: any*/),
                                  (v10/*: any*/),
                                  (v9/*: any*/),
                                  (v29/*: any*/),
                                  (v13/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/)
                                ]
                              },
                              (v32/*: any*/)
                            ]
                          },
                          (v33/*: any*/)
                        ]
                      },
                      (v34/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "yields",
                    "args": null,
                    "handle": "connection",
                    "key": "JobSubComponents_job_yields",
                    "filters": []
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v26/*: any*/),
                      (v28/*: any*/),
                      (v27/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isEnabled",
                        "args": null,
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflowState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "states",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isGangRun",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isRequired",
                            "args": null,
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ]
                      },
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transitions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowTransition",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "toWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v35/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "fromWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v35/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "subComponents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobSubComponentConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobSubComponentEdge",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v32/*: any*/),
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              (v29/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "quantityUOM",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UOM",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v15/*: any*/),
                                  (v5/*: any*/),
                                  (v14/*: any*/)
                                ]
                              },
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/)
                            ]
                          },
                          (v33/*: any*/)
                        ]
                      },
                      (v34/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "subComponents",
                    "args": null,
                    "handle": "connection",
                    "key": "JobSubComponents_subComponents",
                    "filters": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateJobSubComponentMutation",
    "id": null,
    "text": "mutation UpdateJobSubComponentMutation(\n  $input: UpdateJobSubComponentInput!\n) {\n  updateJobSubComponent(input: $input) {\n    jobEdge {\n      ...JobsTable_jobEdges\n      node {\n        ...JobSubComponents_job\n        id\n        importJobNumber\n        jobNumber\n        name\n        status\n        subComponents {\n          edges {\n            usageQty\n            node {\n              id\n              itemNumber\n              name\n              upc\n              partNumber\n              description\n              category {\n                id\n                name\n              }\n              quantityUOM {\n                id\n                name\n                type\n                symbol\n              }\n              weightUOM {\n                id\n                name\n                type\n                symbol\n              }\n              dimensionUOM {\n                id\n                name\n                type\n                symbol\n              }\n              formFieldValues\n              dimensionLength\n              dimensionWidth\n              dimensionHeight\n              weight\n            }\n          }\n        }\n        user {\n          id\n          firstName\n          lastName\n        }\n        order {\n          id\n          promisedAt\n          orderNumber\n          status\n          customer {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment JobsTable_jobEdges on JobEdge {\n  node {\n    id\n    jobNumber\n    importJobNumber\n    name\n    status\n    createdAt\n    user {\n      id\n      ...UserAvatar_user\n    }\n    yields {\n      totalCount\n    }\n    order {\n      id\n      promisedAt\n      customer {\n        id\n        name\n      }\n    }\n    states {\n      id\n      isEnabled\n      status\n      workflowState {\n        id\n        name\n        type\n      }\n    }\n    workflow {\n      id\n      states {\n        id\n        name\n        isRequired\n        type\n      }\n      transitions {\n        id\n        toWorkflowState {\n          id\n        }\n        fromWorkflowState {\n          id\n        }\n      }\n    }\n    ...AddUpdateJobModal_job\n    ...DeleteJobModal_job\n  }\n}\n\nfragment JobSubComponents_job on Job {\n  id\n  ...AddUpdateJobSubComponentModal_job\n  subComponents {\n    edges {\n      ...JobSubComponentsTree_jobSubComponentEdges\n      usageQty\n      node {\n        id\n        name\n        partNumber\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  yields {\n    edges {\n      ...JobSubComponentsTree_jobYieldEdges\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AddUpdateJobSubComponentModal_job on Job {\n  id\n  subComponents {\n    edges {\n      usageQty\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JobSubComponentsTree_jobSubComponentEdges on JobSubComponentEdge {\n  usageQty\n  node {\n    id\n    itemNumber\n    name\n    partNumber\n    upc\n    description\n    category {\n      id\n      name\n    }\n    totalQty\n    quantityUOM {\n      id\n      symbol\n    }\n    lotTracking\n    childItems {\n      edges {\n        usageQty\n        node {\n          id\n          itemNumber\n          name\n          partNumber\n          upc\n          totalQty\n          quantityUOM {\n            id\n            symbol\n          }\n          category {\n            id\n            name\n          }\n          lotTracking\n        }\n      }\n    }\n    ...DeleteJobSubComponentModal_item\n  }\n}\n\nfragment JobSubComponentsTree_jobYieldEdges on JobYieldEdge {\n  node {\n    id\n    quantity\n    item {\n      id\n      itemNumber\n      name\n      partNumber\n      upc\n      totalQty\n      quantityUOM {\n        id\n        symbol\n      }\n      category {\n        id\n        name\n      }\n      lotTracking\n      childItems {\n        edges {\n          usageQty\n          node {\n            id\n            itemNumber\n            name\n            partNumber\n            upc\n            totalQty\n            quantityUOM {\n              id\n              symbol\n            }\n            category {\n              id\n              name\n            }\n            lotTracking\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteJobSubComponentModal_item on Item {\n  id\n  name\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment AddUpdateJobModal_job on Job {\n  id\n  name\n  notes\n  user {\n    id\n  }\n  workflow {\n    id\n    name\n    states {\n      id\n      isGangRun\n    }\n  }\n  order {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        itemNumberUp\n        brokerCustomerOrderNumber\n        formFieldValues\n        overUnderRule\n        overQuantity\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            name\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteJobModal_job on Job {\n  id\n  name\n  order {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd75cfb755e2db418998148556e0dfbeb';
module.exports = node;
